<template>
    <CicPopup
        :title="item.trunkId ? 'Edit SIP Trunk' : 'New SIP Trunk'"
        :saveable="editing"
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <ul class="item-form">
            <li class="form-label-first">
                {{ $t('Name') }}
            </li>
            <li>
                <CicTextbox
                    id="trunk_name"
                    :enabled="editing"
                    :value="item.name"
                    :maxlength="63"
                    @input="(val) => updateFieldValue('name', val)"
                />
            </li>
            <li class="form-label">
                {{ $t('Domain') }}
            </li>
            <li>
                <CicTextbox
                    id="trunk_domain"
                    :enabled="editing && (!item.trunkId || $store.hasRight('EDIT_UNREGISTERED_SIP_TRUNKS'))"
                    :value="item.domain"
                    :maxlength="63"
                    @input="(val) => updateFieldValue('domain', val)"
                />
            </li>
            <li class="form-label">
                {{ $t('Port') }}
            </li>
            <li>
                <CicNumber
                    id="trunk_port"
                    :enabled="editing && (!item.trunkId || $store.hasRight('EDIT_UNREGISTERED_SIP_TRUNKS'))"
                    :value="item.port"
                    :min="0"
                    :max="65535"
                    @input="(val) => updateFieldValue('port', val)"
                />
            </li>
            <template v-if="$store.hasRight('EDIT_SIP_BREAKOUT_SERVICE')">
                <li class="form-label">
                    {{ $t('Use Breakout Services') }}
                </li>
                <li>
                    <CicCheckbox
                        id="trunk_breakout"
                        :enabled="editing"
                        :value="item.breakout"
                        @input="(val) => updateFieldValue('breakout', val)"
                    />
                </li>
                <template v-if="item.breakout">
                    <li class="form-label">
                        {{ $t('External Service') }}
                    </li>
                    <li>
                        <CicSelect
                            id="trunk_external_service"
                            :enabled="editing"
                            :options="services"
                            :value="item.externalServiceId"
                            @input="(val) => updateFieldValue('externalServiceId', val)"
                        />
                    </li>
                    <li class="form-label">
                        {{ $t('External Application') }}
                    </li>
                    <li>
                        <CicSelect
                            id="trunk_external_app"
                            :enabled="editing"
                            :options="externalApps"
                            :value="item.externalApp"
                            @input="(val) => updateFieldValue('externalApp', val)"
                        />
                    </li>
                    <li class="form-label">
                        {{ $t('Internal Service') }}
                    </li>
                    <li>
                        <CicSelect
                            id="trunk_internal_service"
                            :enabled="editing"
                            :options="services"
                            :value="item.internalServiceId"
                            @input="(val) => updateFieldValue('internalServiceId', val)"
                        />
                    </li>
                    <li class="form-label">
                        {{ $t('Internal Application') }}
                    </li>
                    <li>
                        <CicSelect
                            id="trunk_internal_app"
                            :enabled="editing"
                            :options="internalApps"
                            :value="item.internalApp"
                            @input="(val) => updateFieldValue('internalApp', val)"
                        />
                    </li>
                    <li class="form-label">
                        {{ $t('Breakout Digits') }}
                    </li>
                    <li>
                        <CicTextbox
                            id="trunk_digits"
                            :enabled="editing"
                            :value="item.digits"
                            :maxlength="16"
                            @input="(val) => updateFieldValue('digits', val)"
                        />
                    </li>
                    <li class="form-label">
                        {{ $t('Stop Recording') }}
                    </li>
                    <li>
                        <CicCheckbox
                            id="trunk_stop_record"
                            :enabled="editing"
                            :value="item.stopRecording"
                            @input="(val) => updateFieldValue('stopRecording', val)"
                        />
                    </li>
                </template>
            </template>
        </ul>
    </CicPopup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicNumber from '@/components/inputs/CicNumber';
    import CicSelect from '@/components/inputs/CicSelect';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'EditSipTrunk',
        components: {
            CicCheckbox,
            CicNumber,
            CicPopup,
            CicSelect,
            CicTextbox,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
            externalApps: {
                type: Array,
                required: true,
            },
            internalApps: {
                type: Array,
                required: true,
            },
            services: {
                type: Array,
                required: true,
            },
        },
        emits: ['blur', 'change', 'input'],
        data() {
            return {
                editing: false,
            };
        },
        created() {
            this.editing = !this.item.trunkId || this.$store.hasRight('EDIT_SIP_TRUNKS');
        },
        methods: {
            updateFieldValue(field, val) {
                this.$emit('change', field, val);
            },
        },
    };
</script>
